import { useAuth } from 'context';
import { AuthOverlay } from 'components/auth-overlay';
import { AuthOverlayOtp } from 'components/auth-overlay-otp';
import { SpinnerFullPage } from '@updater/ui-uds';
import { useIsAuthenticated } from '@updater/auth';
import { PropsWithChildren } from 'react';
import { useFeature } from 'context/growthbook/useFeature';

export const LoginRequired: React.FC<PropsWithChildren> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  // TODO: nix every use of currentUserUUID before removing
  const { currentUserUUID } = useAuth();
  /* Experiment to remove the `Password` screen */
  const { value: otpLoginEnabled, loading: otpLoginLoading } = useFeature(
    'consumer_otp_login_enabled'
  );

  if (!isAuthenticated) {
    if (otpLoginLoading) {
      return null;
    }

    return otpLoginEnabled ? (
      <AuthOverlayOtp title="Welcome back!" />
    ) : (
      <AuthOverlay title="Welcome back!" />
    );
  }

  if (currentUserUUID == null) {
    return <SpinnerFullPage />;
  }

  return <>{children}</>;
};
